export function toggleBodyClass(bodyClass: string, toggleOn: boolean) {
    const hasBodyClass = document.body.classList.contains(bodyClass);

    if (toggleOn && hasBodyClass) {
        return;
    }

    if (toggleOn && !hasBodyClass) {
        document.body.classList.add(bodyClass);
    } else {
        document.body.classList.remove(bodyClass);
    }
}
